import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";
import { store } from "../../store/store";



export class PortalLiveApi extends AxiosGlobal {

    // ==================== PUBLIC - NO AUTH ====================

    registerPartner(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/register`, data);
    }

    loginPartner(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/login`, data);
    }

    forgotPassword(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/forgot-password`, data);
    }

    // ==================== AUTHENTICATED - PORTAL TOKEN ====================

    portalSession(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/profile`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // ==================== INVOICES ====================

    getInvoices(status?: string): AxiosPromise<any> {
        const query = status ? `?status=${status}` : '';
        return this.axios.get(`${configs.context}/v1/portal/invoices${query}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getInvoice(id: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/invoices/${id}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    downloadInvoice(id: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/invoices/${id}/download`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    logoutPartner(): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/logout`, {}, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Profile
    getProfile(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/profile`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    updateProfile(data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/v1/portal/profile`, data, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Dashboard
    getDashboard(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/dashboard`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // API Keys
    getApiKeys(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/api-keys`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    requestKeyRotation(keyId: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/api-keys/${keyId}/request-rotation`, {}, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Usage
    getUsage(period: number): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/usage?period=${period}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getUsageDaily(period: number): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/usage/daily?period=${period}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Wallet
    getWallet(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/wallet`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    getWalletTransactions(page: number): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/wallet/transactions?page=${page}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Webhooks
    getWebhooks(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/webhooks`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    createWebhook(data: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/webhooks`, data, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    updateWebhook(id: any, data: any): AxiosPromise<any> {
        return this.axios.put(`${configs.context}/v1/portal/webhooks/${id}`, data, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    deleteWebhook(id: any): AxiosPromise<any> {
        return this.axios.delete(`${configs.context}/v1/portal/webhooks/${id}`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    testWebhook(id: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/webhooks/${id}/test`, {}, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // Quick Start / Docs
    getQuickStart(): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/quick-start`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    // ==================== API KEY REVEAL + REGENERATE ====================

    revealApiKey(keyId: any): AxiosPromise<any> {
        return this.axios.get(`${configs.context}/v1/portal/api-keys/${keyId}/reveal`, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }

    regenerateApiKey(keyId: any): AxiosPromise<any> {
        return this.axios.post(`${configs.context}/v1/portal/api-keys/${keyId}/regenerate`, {}, {
            headers: { "Content-Type": "application/json", "Accept": "application/json", "Authorization": `Bearer ${store.getState().data.login.value.portalToken}`, "Access-Control-Allow-Origin": "*" },
        });
    }


}